import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PhoneDropdownItem } from '../../../models/shared/phone-dropdown-item';
import { PhoneCountryCodeService } from './phone-country-code.service';
import { PhoneCountryCodeDropdownInputComponent } from './country-code-dropdown-input/phone-country-code-dropdown-input.component';
import { PhoneCountryCodeNumberInputComponent } from './phone-number-input/phone-country-code-number-input.component';

@Component({
  selector: 'app-phone-country-code',
  templateUrl: './phone-country-code.component.html',
  styleUrls: ['./phone-country-code.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, PhoneCountryCodeDropdownInputComponent, PhoneCountryCodeNumberInputComponent],
  providers: [PhoneCountryCodeService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneCountryCodeComponent {
  @Input() formGroup!: FormGroup;
  @Input() phoneNumberControlName!: string;
  @Input() countryCodeControlName!: string;
  @Input() countryCodes: PhoneDropdownItem[] = [];
  @Input() error: boolean = false;
  @Input() controlId: string = '';
}
